$( document ).ready(function() {

	$(".btn-check-order").click(function(e) {
		e.preventDefault();

		var orderID = $('input.order-id').val();
		jQuery.ajax({
		    type: 'GET',		   
		    url: 'https://b678d995f7df8a6dfd2827cccbaeea95:0c541b20a9a48b9f4d1b4a754d416ebd@monngonmoingay.myshopify.com/admin/orders.json',
		    success: function(response1) {
		    	response1.orders.forEach(function(data2) {
				   if( data2.id == orderID ){
				   		jQuery.ajax({
						    type: 'GET',
						    url: '/admin/orders.json?ids='+orderID,
						    success: function(response) {
						    	console.log(response)
						    	$('#form-return-order').hide();
						    	$('#order_return_detail').show();
					
						    	response.orders[0].line_items.forEach(function(data) {
						    		console.log(data);
						    		var dataProduct = data.product_id;
						    		var dataProductVariant = data.variant_id;
						    		var contentProduct = "<div class='product-item'>";
						    		$.ajax({
						    			type: 'GET',
						    			url: '/admin/products/'+dataProduct+'/variants/'+ dataProductVariant +'.json', 
						    			success: function(result){
						    				console.log(result);
										    var idvariant = result.variant.image_id;
								    		$.ajax({
								    			type: 'GET',
								    			data: {
											    	status: 'any'
											    },
								    			url: '/admin/products.json?ids='+ dataProduct , 
								    			success: function(result1){
								    				result1.products[0].images.forEach(function(dataq) {
										    			if(dataq.id == idvariant){
										    				var srcimg = dataq.src;
										    				if (response.orders[0].phone == null ){
													    		var phoneNumber = 'No phone number';
													    	}
													    	else{
													    		var phoneNumber = response.orders[0].phone;
													    	}
													    	var customerInfo = "<p> Email:"+response.orders[0].email+"</p><p> Phone: "+ phoneNumber+"</p>";
													    	var shippingAdd = "<p>"+response.orders[0].shipping_address.name 
													    					  +"</p><p>"+response.orders[0].shipping_address.address1+"</p><p>"
													    					  +"</p><p>"+response.orders[0].shipping_address.address2+"</p><p>"
													    					  +"</p><p>"+response.orders[0].shipping_address.city+" "
													    					  + response.orders[0].shipping_address.province_code +" "
													    					  + response.orders[0].shipping_address.zip 
													    					  +"</p><p>" +response.orders[0].shipping_address.country
													    					  +"</p><p>"+response.orders[0].shipping_address.phone+"</p>";
													    	var billingAdd = "<p>"+response.orders[0].billing_address.name 
													    					  +"</p><p>"+response.orders[0].billing_address.address1+"</p><p>"
													    					  +"</p><p>"+response.orders[0].billing_address.address2+"</p><p>"
													    					  +"</p><p>"+response.orders[0].billing_address.city+" "
													    					  + response.orders[0].billing_address.province_code +" "
													    					  + response.orders[0].billing_address.zip 
													    					  +"</p><p>" +response.orders[0].shipping_address.country
													    					  +"</p><p>"+response.orders[0].shipping_address.phone+"</p>";
													    	$('.order-custom .contact-information .customer-infor').append(customerInfo);
													    	$('.order-custom .shipping-address .shipping-address-info').append(shippingAdd);
													    	$('.order-custom .billing-address .billing-address-info').append(billingAdd);
										    				contentProduct = contentProduct +"<div class='id-order'><input type='checkbox'></div>"+
										    				"<div class='product-image'><img src='"+ dataq.src +"'></div>";
										    				contentProduct = contentProduct + "<div class='product-info'><p>" + data.title +"</p><p>"
						    							 		+ data.variant_title +"</p><p>SKU: "
						    							 		+ data.sku  +"</p></div><div class='product-price'><p>"
						    							 		+"$ "+data.price +"  x  "+ 
						    							 		+ data.quantity
						    							 		+"</p></div><div><p>$ " +data.pre_tax_price+"</p></div></div>";
							        						$(".order-product-list").append(contentProduct); 
										    				console.log(contentProduct);
										    			}
										    		});
										    	}
											});
										}
									});
						    	
							    });
						    },
						    error: function(error) {
						        console.log("Error: "+ error);
						    }
						}); 	
				   }
				   else{
				   		$('.note-order').show();
				   }
				});
		    },
		    error: function(error1) {
		        console.log("Error: "+ error1);
		    }
		});
	});
});

/* Edwin Code Starts 
30 Aug 2019
*/
var available_products_list = Array();
$(document).ready(function(e){

	if($(".template-search").length > 0) {
		var original_title = $("title").text();
		var replace_this_count = $("[data-totalresults]").attr("data-totalresults");
		var replace_this_count_with = $("[data-totalmanipulatedresults]").attr("data-totalmanipulatedresults");
		var new_title = original_title.replace(replace_this_count,replace_this_count_with);
		$("title").text(new_title);
	}
	//sections -> product-template.liquid
	//ID = #ProductSelect-product-template
	//Class = .product-form__variants.no-js
	if($("#ProductSelect-product-template").length > 0) {
		//We only want to have this if there's ID of all products available
		//SelectedParts
		var current_first_available  = $("#ProductSelect-product-template option:selected").text().trim();
		var current_first_availalble_array = current_first_available.split(" / ");
		$("input[name='option-0'][value='"+current_first_availalble_array[0]+"']").trigger('click');
		$("input[name='option-1'][value='"+current_first_availalble_array[1]+"']").trigger('click');
		$("input[name='option-2'][value='"+current_first_availalble_array[2]+"']").trigger('click');
		$("#ProductSelect-product-template > option").each(function(ix,em){
			var product_full_name = $(em).text().trim();
			if($(em).attr('disabled') == 'disabled') {
				available_products_list[product_full_name] = false;
			} else {
				available_products_list[product_full_name] = true;
			}
		});
		$(document).on("change","input[name='option-0']",function(e){
			sort_list(false);
		});

      var test3rdOption = $("input[name='option-2']");
      //console.log(test3rdOption.length);
      if (test3rdOption.length > 0) {
        $(document).on("change","input[name='option-2']",function(e){
			sort_list(true);
		});
      } else {
        $(document).on("change","input[name='option-1']",function(e){
			sort_list(true);
		});
      }

		/*$(document).on("change","input[name='option-2']",function(e){
			sort_list(true);
		});*/

		sort_list(true);

		function sort_list(revertToFirst) {
			//console.log("revertToFirst ==> " + revertToFirst);
			$(".size.product_unavailable").removeClass("product_unavailable");

			$("input[name='option-0']").each(function(ix,em2) {
				var sel_part_0 = $(em2).val();

				var sel_part_1 = $("input[name='option-1']:checked").val();
				if(typeof sel_part_1 == "undefined") {
					sel_part_1 = $("input[name='option-1']").val();
				}

              
              var test3rdOption = $("input[name='option-2']");
              //console.log(test3rdOption.length);
              if (test3rdOption.length > 0) {
                var sel_part_2 = $("input[name='option-2']:checked").val();
				if(typeof sel_part_2 == "undefined") {
					sel_part_2 = $("input[name='option-2']").val();
				}
				var current_string_to_compare = sel_part_0 + " / " + sel_part_1 + " / " + sel_part_2;
                //console.log('passed');
                if(available_products_list[current_string_to_compare] != true) {
					$(em2).parents(".swatch-element").eq(0).addClass("product_unavailable");
				}
              } else {
                var current_string_to_compare = sel_part_0 + " / " + sel_part_1 ;
                //console.log(current_string_to_compare);
                if(available_products_list[current_string_to_compare] != true) {
					$(em2).parents(".swatch-element").eq(0).addClass("product_unavailable");
				}
              }
              
              
				//console.log("current_string_to_compare" , current_string_to_compare, available_products_list);
				
              
              
              
			});

			$("input[name='option-2']").each(function(ix,em3) {
				var sel_part_2 = $(em3).val();

				var sel_part_0 = $("input[name='option-0']:checked").val();
				if(typeof sel_part_0 == "undefined") {
					sel_part_0 = $("input[name='option-0']").val();
				}

				var sel_part_1 = $("input[name='option-1']:checked").val();
				if(typeof sel_part_1 == "undefined") {
					sel_part_1 = $("input[name='option-1']").val();
				}
				var current_string_to_compare = sel_part_0 + " / " + sel_part_1 + " / " + sel_part_2;
				var isUnavailable = true;
				$("#ProductSelect-product-template > option").each(function(ix,em){
					var product_full_name = $(em).text().trim();
					if($(em).attr('disabled') == 'disabled') {
						if (product_full_name.indexOf(sel_part_2) !== -1  ) {

						}
					} else {
						if (product_full_name.indexOf(sel_part_2) !== -1  ) {
							isUnavailable = false;
						}
					}
				});

				if(isUnavailable == true) {
					$(em3).parents(".swatch-element").eq(0).addClass("product_unavailable");
				}

				if(revertToFirst == true) {
					$('[data-option-index="0"]').find(".swatch-element").each(function(ix,em){
						if ($(em).hasClass('product_unavailable') ) {
						} else {
							   $(em).trigger('click');
							   return false;
						}
				   });
				}
				// if(available_products_list[current_string_to_compare] != true) {
				// 	$(em3).parents(".swatch-element").eq(0).addClass("product_unavailable");
				// }
			});
		}
	}
});



// $('.afterpay-link-inner').html('More Info');